<template>
	<div class="editProfile">
		<div class="vx-row">
			<div class="vx-col w-full lg:w-3/4 xl:w-3/5">
				<vx-card>
					<h1 class="mb-5">{{ $t('clientEditing') }}</h1>
					<div class="vx-row flex">
						<div class="vx-col w-1/2 mb-2">
							<vs-input
								:label="$t('personName')"
								name="name"
								v-validate="'min:3'"
								v-model="name"
							/>
							<span
								:class="{ 'text-transparent': !errors.first('name') }"
								class="text-danger text-sm"
							>
								{{ $t('fieldFilledIncorrect') }}
							</span>
						</div>
						<div class="vx-col w-1/2 mb-2">
							<vs-input
								:label="$t('surname')"
								name="surname"
								v-validate="'min:3'"
								v-model="surname"
							/>
							<span
								:class="{ 'text-transparent': !errors.first('surname') }"
								class="text-danger text-sm"
							>
								{{ $t('fieldFilledIncorrect') }}
							</span>
						</div>
						<div class="vx-col w-1/2 mb-2">
							<div class="vs-component vs-con-input-label vs-input vs-input-primary">
								<label class="vs-input--label">{{ $t('sex') }}</label>
								<div class="vs-con-input">
								</div>
								<v-select
									v-model="sex"
									:reduce="country => country.id"
									label="name"
									v-validate="''"
									name="sex"
									:options="genders" :dir="$vs.rtl ? 'rtl' : 'ltr'"
									class="single-row-select"
								/>
							</div>
							<span
								:class="{ 'text-transparent': !errors.first('sex') }"
								class="text-danger text-sm"
							>
								{{ $t('fieldFilledIncorrect') }}
							</span>
						</div>
						<div class="vx-col w-1/2 mb-2">
							<div class="vs-component vs-con-input-label vs-input vs-input-primary">
								<label class="vs-input--label">{{ $t('country') }}</label>
								<div class="vs-con-input">
								</div>
								<v-select
									v-model="country"
									:reduce="country => country.id"
									label="name"
									v-validate="''"
									name="country"
									:options="countries"
									:dir="$vs.rtl ? 'rtl' : 'ltr'"
									class="single-row-select"
								/>
							</div>
							<span
								:class="{ 'text-transparent': !errors.first('country') }"
								class="text-danger text-sm"
							>
								{{ $t('fieldFilledIncorrect') }}
							</span>
						</div>
						<div class="vx-col w-1/2 mb-2">
							<vs-input
								:label="$t('additionalEmail')"
								name="email_atach"
								v-validate="'email|min:3'"
								v-model="email_secondary"
							/>
							<span
								:class="{ 'text-transparent': !errors.first('email_atach') }"
								class="text-danger text-sm"
							>
								{{ $t('fieldFilledIncorrect') }}
							</span>
						</div>
						<div class="vx-col w-1/2 mb-2">
							<vs-phone
								:label="$t('phone')"
								name="phone"
								v-validate="'min:7|max:14'"
								v-model="phone"
							/>
							<span
								:class="{ 'text-transparent': !errors.first('phone') }"
								class="text-danger text-sm"
							>
								{{ $t('fieldFilledIncorrect') }}
							</span>
						</div>
						<div class="vx-col w-1/2 mb-2" v-if="package">
							<label class="vs-input--label">{{ $t('packageExpiry') }}</label>
							<div class="vs-con-input"></div>
							<vs-datepicker
								label="Package expiry date"
								v-model="package_expiry_date"
								format="dd.MM.yyyy"
								:to="minDate"
								name="date"
							></vs-datepicker>
							<span
								:class="{ 'text-transparent': !errors.first('phone') }"
								class="text-danger text-sm"
							>
								{{ $t('fieldFilledIncorrect') }}
							</span>
						</div>
					</div>
					<div class="flex flex-end flex-wrap mb-3 my-5">
						<vs-button @click="saveClient" class="mr-5">
							{{ $t('save') }}
						</vs-button>
						<vs-button color="warning" type="border" @click="$router.go(-1)">{{ $t('cancel') }}</vs-button>
					</div>
				</vx-card>
			</div>
		</div>
	</div>
</template>
<script>
import vSelect from "vue-select";
import notifier from "@/mixins/notifier";

export default {
	mixins: [notifier],
	data() {
		return {
			email_secondary: '',
			name: '',
			surname: '',
			phone: '',
			sex: '',
			country: '',
			user: {},
			countries: [],
			genders: [],
			package_expiry_date: null,
			package: null,
		}
	},
	computed: {
		minDate() {
			const today = new Date();
			today.setHours(0, 0, 0, 0);
			return today;
		}
	},
	async mounted () {
		this.countries = (await this.$http.get('/settings/get-countries')).data.data
		this.genders = (await this.$http.get('/settings/get-genders')).data.data

		await this.getUser();

		this.email_secondary = this.user.email_secondary || '';
		this.name = this.user.first_name || '';
		this.surname = this.user.last_name || '';
		this.phone = this.user.phone || '';
		this.sex = this.user.gender;
		this.package = this.user.package;
		if (this.user.package_expiry_date) {
			const [day, month, year] = this.user.package_expiry_date.split('.');
			const date = new Date(year, month - 1, day);
			date.setHours(12, 0, 0, 0); // Встановлюємо час на полудень, щоб уникнути проблем з часовими поясами
			this.package_expiry_date = date;
		}
		if(this.user.country) this.country = this.user.country;
	},
	methods: {
		async getUser(){
			this.user = (await this.$http.get('/manager/client/view/'+this.$route.params.id)).data.data;
		},
		async saveClient(){
			try {
				let validator = await this.$validator.validateAll();
				if(!validator) return ;
				let formData = {
					// "email_secondary": this.email_secondary,
					// "first_name": this.name,
					// "last_name": this.surname,
					// "gender": this.sex,
					// "country": this.country,
					// "phone": this.phone,
				}

				if(this.email_secondary !== '' && this.email_secondary !== null) {
					formData.email_secondary = this.email_secondary;
				}
				if(this.surname !== '' && this.surname !== null) {
					formData.last_name = this.surname;
				}
				if(this.name !== '' && this.name !== null) {
					formData.first_name = this.name;
				}
				if(this.sex !== '' && this.sex !== null) {
					formData.gender = this.sex;
				}
				if(this.country !== '' && this.country !== null) {
					formData.country = this.country;
				}
				if(this.phone !== '' && this.phone !== null) {
					formData.phone = this.phone;
				}
				if(this.user.package && this.user.package !== '' && this.package_expiry_date) {
					formData.package_expiry_date = Math.floor(new Date(this.package_expiry_date).getTime() / 1000);
				}

				await this.$http.post('/manager/client/update/'+this.$route.params.id,formData)
				await this.getUser();

				this.notifySuccess(this.$t('dataIsSaved'));
				this.$router.push('/clientM/'+this.$route.params.id);

			}	catch (e) {
				this.notifyError(e.message);
			}
		},
	},
	components: {
		'v-select': vSelect,
	},
}
</script>
<style scoped lang="scss">
.vs-con-input-label {
	width: 100%;
}
.vx-input-group .vx-input-group-append .append-text.btn-addon .vs-button{
	height: 38px;
	margin-top: 20px;
}
</style>
